export default {

    bind (el, bindings, vnode) {
        const permission = bindings.rawName.replace('v-can:', '');
        const ok = (
            window.user &&
            window.user.permissions &&
            permission &&
            window.user.permissions.indexOf(permission) > -1 ? true : false
        );

        Vue.nextTick(() => {
            if (!ok) {
                el.remove();
            }
        });
    }

}
